import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { TheNeed } from './components/TheNeed';
import { WhyCancun } from './components/WhyCancun';
import { OurVision } from './components/OurVision';
import { GlobalNetwork } from './components/GlobalNetwork';
import { WeddingEcosystem } from './components/WeddingEcosystem';
import { WeddingDateInquiry } from './components/WeddingDateInquiry';
import { WhatThisMakesPossible } from './components/WhatThisMakesPossible';
import { FundingPathways } from './components/FundingPathways';
import { FoundingCircle } from './components/FoundingCircle';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { StickyMobileCTA } from './components/StickyMobileCTA';
import { LanguageProvider } from './lib/LanguageContext';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { PitchDeck } from './pages/PitchDeck';
function LandingPage() {
  return <>
      <Navbar data-id="element-0" data-mp="3ikh8gaq64uzi" />

      <main data-id="element-1" data-mp="3ikqwvtvkeu33">
        <Hero data-id="element-2" data-mp="3ij63w8owfj7c" />
        <TheNeed data-id="element-3" data-mp="3ijpbowku4r7n" />
        <WhyCancun data-id="element-4" data-mp="3ii4t85bsoyq5" />
        <OurVision data-id="element-5" data-mp="3mlavl1vse5rc" />
        <GlobalNetwork data-id="element-6" data-mp="3mkrbpfmkt7ao" />
        <WeddingEcosystem data-id="element-7" data-mp="3mjzsz5e2v41t" />
        <WeddingDateInquiry data-id="element-8" data-mp="3mjgclt42snpw" />
        <WhatThisMakesPossible data-id="element-9" data-mp="3rbr9en3irte8" />
        <FundingPathways data-id="element-10" data-mp="3rdkgg3i1ofmr" />
        <FoundingCircle data-id="element-11" data-mp="3recdzjv7cnfo" />
        <FAQ data-id="element-12" data-mp="5ygolyg4xb6" />
      </main>

      <footer data-id="element-13" data-mp="682dxcgkib2">
        <FinalCTA data-id="element-14" data-mp="4n6a3ahwrb3" />
      </footer>

      <StickyMobileCTA data-id="element-15" data-mp="7sulgbavp5r" />
    </>;
}
export function App() {
  return <LanguageProvider data-id="element-16" data-mp="2zmo6bandcp36">
      <BrowserRouter data-id="element-17" data-mp="2zn678kkz7rhf">
        <div className="min-h-screen bg-ivory font-sans text-navy antialiased selection:bg-saffron/30" data-id="element-18" data-mp="33mf2jtvnzxf3">
          <Routes data-id="element-19" data-mp="38m1iwc6shts4">
            <Route path="/" element={<LandingPage data-id="element-21" data-mp="38k6vmr81ppkv" />} data-id="element-20" data-mp="38kqcs5pvg9xu" />
            <Route path="/pitch-deck" element={<PitchDeck data-id="element-23" data-mp="3dl4lzr37lpxg" />} data-id="element-22" data-mp="38o4f5dyjcj5a" />
          </Routes>
        </div>
      </BrowserRouter>
    </LanguageProvider>;
}